// extracted by mini-css-extract-plugin
export default {"backButton":"ResetPasswordForm_backButton__g1YX3","backIcon":"ResetPasswordForm_backIcon__39Set"};